<template>
  <div class="mx-md-3 mx-0 my-5">
    <div class="row py-3 border">
      <div class="col-md-5">
        <b-skeleton height="240px"></b-skeleton>
      </div>
      <div class="col-md-7">
        <b-skeleton height="30px" class="my-3" width="50%"></b-skeleton>
        <div class="mt-4">
          <b-skeleton v-for="i in 3" :key="i" height="10px"></b-skeleton>
          <b-skeleton height="10px" width="50%"></b-skeleton>
        </div>
      </div>
    </div>
    <div class="row py-3 border border-top-0" v-for="i in 3" :key="i">
      <div class="col-md-5">
        <b-skeleton height="10px" width="40%"></b-skeleton>
        <b-skeleton class="mt-2" height="20px" width="60%"></b-skeleton>
        <div class="d-flex mt-3">
          <b-skeleton height="10px" class="mr-1" width="20%"></b-skeleton>
          <b-skeleton height="10px" width="20%"></b-skeleton>
        </div>
      </div>
      <div class="col-md-3">
        <b-skeleton height="10px" width="30%"></b-skeleton>
        <div class="d-flex mt-1">
          <b-skeleton height="35px" class="mr-1" width="50%"></b-skeleton>
          <b-skeleton height="10px" width="20%"></b-skeleton>
        </div>
        <b-skeleton height="10px" width="40%"></b-skeleton>
      </div>
      <div class="col-md-4">
        <div class="d-flex justify-content-between">
          <div style="width: 50%">
            <b-skeleton height="10px" width="60%"></b-skeleton>
            <b-skeleton height="10px" class="mt-2" width="40%"></b-skeleton>
            <b-skeleton height="30px" class="mt-2" width="70%"></b-skeleton>
            <b-skeleton height="10px" class="mt-3" width="80%"></b-skeleton>
          </div>
          <div style="width: 20%">
            <b-skeleton height="10px" width="90%"></b-skeleton>
            <b-skeleton class="mt-1" height="35px"></b-skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AvailabilitySkeleton",
};
</script>
